import axios from 'axios';
import { getEnv } from '@/environment';

const abonnementstjenesterUrl = getEnv('VUE_APP_ABONNEMENTSTJENESTER_URL');

const index = {
  getAvfallAbonnement(identifikator, abonnement) {
    const eksternId = abonnement.eksternId.replace('´', '').replace('`', '').replace("'", '');

    return axios
      .post(`${abonnementstjenesterUrl}/abonnementer/hent/${abonnement.abonnementstypeId}/${eksternId}`, {
        fodselsnr: identifikator,
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getAbonnementer(identifikator) {
    return axios
      .post(`${abonnementstjenesterUrl}/abonnementer`, { fodselsnr: identifikator })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  updateAbonnement(abonnement) {
    if (!abonnement.abonnementstypeId || !abonnement.eksternId) return Promise.reject({ status: 404 });

    const url = `${abonnementstjenesterUrl}/abonnementer/opprett/${abonnement.abonnementstypeId}/${abonnement.eksternId}`;
    return axios
      .put(url, abonnement)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  stopAbonnement(abonnement, identifikator = null) {
    if (!abonnement.abonnementstypeId || !abonnement.eksternId) return Promise.reject({ status: 404 });
    if (!abonnement.fodselsnr && !identifikator) return Promise.reject('Fødselsnummer mangler', { status: 404 });
    const url = `${abonnementstjenesterUrl}/abonnementer/avslutt/${abonnement.abonnementstypeId}/${abonnement.eksternId}`;

    return axios
      .post(url, {
        fodselsnr: abonnement.fodselsnr || identifikator,
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getAbonnementstyper() {
    return axios
      .get(`${abonnementstjenesterUrl}/abonnementstyper`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },
};

export default index;
